import { Level } from '../types/Auth'

export const translation = {
  projectName: 'MPS ARCHONIC - Design and Build',

  header: {
    navigation: {
      default: [
        {
          name: 'Anmelden',
          link: '/',
        },
      ],
      MEMBER: [
        {
          name: 'Protokolle',
          link: '/dashboard/protocols',
          activeOn: '/dashboard/protocols',
        },
        {
          name: 'Assistenz',
          link: '/dashboard/chat',
          activeOn: '/dashboard/chat',
        },
        {
          name: 'CRM',
          link: '/dashboard/crm',
          activeOn: '/dashboard/crm',
        },
        {
          name: 'Datenbank',
          link: '/dashboard/database',
          activeOn: '/dashboard/database',
        },
        {
          name: 'Einstellungen',
          link: '/dashboard/settings',
          activeOn: '/dashboard/settings',
        },
      ],
      isLoggedIn: {
        name: 'Abmelden',
      },
    },
    logoText: 'Design and Build',
  },

  dashboard: {
    protocol: {
      new: {
        title: 'Neues Protokoll',
        description: 'Erstelle ein neues Protokoll',
        audioFileAllowedFormats: 'Erlaubte Formate: mp3, mp4, mpeg, mpga, m4a, wav, webm',
        audioFileRequired: 'Bitte eine Audiodatei auswählen.',
        create: 'Hochladen & Protokoll erstellen',
        uploading: 'Wird hochgeladen…',
        processingError: 'Verarbeitung fehlgeschlagen.',
        microphoneError: 'Mikrofon-Zugriff verweigert oder nicht verfügbar.',
        noAudioData: 'Keine Audiodaten aufgenommen.',
        uploadUrlError: 'Upload-URL konnte nicht abgerufen werden.',
        audioUploadError: 'Audio-Upload fehlgeschlagen.',
      },
      list: {
        title: 'Protokolle',
        description: 'Liste aller Protokolle',
        defaultTitle: 'Protokoll',
        emptyTitle: 'Noch keine Protokolle',
        emptyDescription: 'Laden Sie eine Sprachaufnahme hoch, um Ihr erstes Protokoll zu erstellen.',
        createFirst: 'Erstes Protokoll erstellen',
        newProtocolCta: '+ Neues Protokoll',
        view: 'Anzeigen',
      },
      detail: {
        backToOverview: 'Zurück zur Übersicht',
        openAssistenz: 'Assistenz',
        title: 'Protokoll',
        description: 'Detailansicht eines Protokolls',
        controls: {
          transcribe: 'Transcriben',
          transcribeLoading: 'Transcriben wird ausgeführt…',
          pdf: 'PDF Export',
          pdfLoading: 'PDF wird exportiert…',
          interpret: 'Interpretieren',
          interpretLoading: 'Interpretieren wird ausgeführt…',
          prettify: 'Transkript formatieren',
          prettifyLoading: 'Wird formatiert…',
        },
        tabs: {
          insight: 'Ergebnis',
          transcript: 'Transkript',
        },
        deal: {
          title: 'Deal',
          suggested: 'KI-Vorschlag',
          assigned: 'Zugewiesen',
          confirmSuggestion: 'Vorschlag übernehmen',
          chooseOther: 'Anderen Deal wählen',
          none: 'Kein Deal',
          selectPlaceholder: 'Deal auswählen…',
          save: 'Zuweisen',
          saved: 'Gespeichert',
        },
      },
      attributes: {
        deal: 'Deal',
        protocolType: 'Protokolltyp',
        audioFile: 'Audiodatei',
        createdAt: 'Erstellt am',
        createdBy: 'Erstellt von',
        updatedAt: 'Aktualisiert am',
        updatedBy: 'Aktualisiert von',
        recordingWindow: 'Aufnahme',
      },
    },
    crm: {
      title: 'CRM',
      description: 'Synchronisieren und durchsuchen Sie Ihre CRM-Daten.',
      sync: 'Synchronisieren',
      syncLoading: 'Synchronisieren…',
      synced: 'Synchronisiert',
      searchPlaceholder: 'Suchen…',
      tabCompanies: 'Unternehmen',
      tabPeople: 'Personen',
      tabDeals: 'Deals',
      entrySingular: 'Eintrag',
      entryPlural: 'Einträge',
      ofTotal: 'von',
      emptyState: {
        noCompanies: 'Keine Unternehmen',
        noPeople: 'Keine Personen',
        noDeals: 'Keine Deals',
        hint: 'Starten Sie eine Synchronisierung, um Daten zu laden.',
      },
      syncError: {
        title: 'Fehler bei der Synchronisierung',
      },
    },
    chat: {
      title: 'Assistenz',
      description: 'Stellen Sie Fragen zu allen bisherigen Protokollen.',
      askProtocols: 'Stellen Sie Fragen zu Ihren Protokollen',
      searchDescription: 'Durchsucht alle indexierten Protokolle',
      suggestion1: 'Was wurde im letzten Protokoll besprochen?',
      suggestion2: 'Welche offenen Punkte gibt es?',
      suggestion3: 'Kurzfassung des Protokolls',
      clearHistory: 'Verlauf löschen',
      messagePlaceholder: 'Nachricht eingeben…',
      errorLoadAnswer: 'Antwort konnte nicht geladen werden.',
      errorSend: 'Fehler beim Senden.',
      storeChroma: 'ChromaDB',
      storePinecone: 'Pinecone',
      storeChromaDesc: 'Lokaler Vektorspeicher',
      storePineconeDesc: 'Cloud-basierter Vektorspeicher',
      contextFull: 'Stellen Sie Fragen zu allen bisherigen Protokollen.',
      contextRestricted: 'Kontext auf die gewählte Auswahl beschränkt.',
      editInterpretation: 'Interpretation bearbeiten',
      editInterpretationDescription:
        'Änderung in eigenen Worten beschreiben, z. B. „Todo hinzufügen: Angebot bis 15.03“ oder „Zusammenfassung kürzer fassen“.',
      editInterpretationPlaceholder: 'z. B. Todo hinzufügen: Angebot erstellen bis 15.03',
      editInterpretationApply: 'Anwenden',
      editInterpretationSuccess: 'Interpretation wurde aktualisiert.',
      editInterpretationError: 'Bearbeitung fehlgeschlagen.',
      editInterpretationLoading: 'Wird angewendet…',
    },
    database: {
      title: 'Datenbank',
      description: 'Alle indexierten Protokoll-Chunks aus ChromaDB. Diese Vektordaten werden für die semantische Suche im Assistenz-Chat verwendet.',
      loadData: 'Daten laden',
      loadDataLoading: 'Laden…',
      resetDb: 'Datenbank zurücksetzen',
      confirmResetTitle: 'Datenbank wirklich zurücksetzen?',
      confirmResetText:
        'Alle {count} Chunks werden unwiderruflich aus ChromaDB gelöscht. Die semantische Suche im Chat steht danach nicht mehr zur Verfügung, bis die Daten neu indexiert werden.',
      deleteConfirm: 'Ja, alles löschen',
      deleteLoading: 'Wird gelöscht…',
      resetSuccess: 'Datenbank wurde zurückgesetzt.',
      chunksDeleted: '{count} Chunks gelöscht.',
      emptyHint: 'Klicken Sie auf „Daten laden", um die ChromaDB-Inhalte anzuzeigen.',
      searchPlaceholder: 'Suchen (Text, Protokoll, Projektnr., Typ…)',
      chunksCount: '{filtered} von {total} Chunks',
      chunksFiltered: 'gefiltert nach „{search}"',
      metadataToggle: 'Metadaten anzeigen',
      dataLoadError: 'Daten konnten nicht geladen werden.',
      loadError: 'Fehler beim Laden.',
      resetError: 'Datenbank konnte nicht zurückgesetzt werden.',
      resetErrorGeneric: 'Fehler beim Zurücksetzen.',
    },
    settings: {
      title: 'Einstellungen',
      description: 'Einstellungen',
      tabs: {
        account: 'Konto',
        protocolTypes: 'Protokolarten',
        system: 'System',
      },
      account: {
        changePassword: 'Passwort ändern',
        newPassword: 'Neues Passwort',
        newPasswordRepeat: 'Neues Passwort wiederholen',
        passwordChanged: 'Passwort wurde geändert.',
        passwordError: 'Passwort konnte nicht geändert werden.',
        passwordsDontMatch: 'Die Passwörter stimmen nicht überein.',
      },
      system: {
        centralStation: 'Central Station CRM',
        centralStationDescription: 'API-Schlüssel und Subdomain für die CRM-Synchronisation.',
        apiKey: 'API-Schlüssel',
        apiKeyPlaceholder: 'API-Schlüssel eingeben (leer lassen = unverändert)',
        subdomain: 'Subdomain',
        subdomainPlaceholder: 'z. B. accountname',
        saved: 'Einstellungen gespeichert.',
        saveError: 'Speichern fehlgeschlagen.',
      },
      createProtocolType: 'Neuen Protokolltypen erstellen',
      edit: 'Bearbeiten',
      newProtocolType: 'Neuer Protokolltyp',
      protocolTypeNamePlaceholder: 'z. B. Baubesprechung',
      protocolTypePromptPlaceholder: 'z. B.: Du bist ein Assistent für Bauprotokolle. Analysiere das Transkript und extrahiere...',
      protocolTypePromptHint: 'Kontext und Anweisungen für die KI. Wird beim Verarbeiten von Sprachnotizen verwendet.',
      interpretationPromptLabel: 'Interpretation-Prompt',
      generatePromptDescriptionLabel: 'Prompt-Beschreibung (einfache Worte)',
      generatePromptDescriptionPlaceholder: 'z. B. Zusammenfassung, offene Aufgaben, erwähnte Personen',
      generatePromptButton: 'Prompt mit KI generieren',
      generatePromptLoading: 'Generiere …',
      generatePromptError: 'Generierung fehlgeschlagen.',
      createError: 'Erstellen fehlgeschlagen.',
      saveError: 'Speichern fehlgeschlagen.',
      nameRequired: 'Name ist erforderlich.',
      createSuccess: 'Protokolltyp erstellt.',
      saveSuccess: 'Änderungen gespeichert.',
      removeSuccess: 'Protokolltyp entfernt.',
      removeError: 'Entfernen fehlgeschlagen.',
    },
  },

  login: {
    headline: 'Anmelden',
    cta: 'Anmelden',
    error: 'Anmeldung fehlgeschlagen. Falsche E-Mail oder Passwort.',
  },

  footer: {
    links: 'Links',
    followUs: 'Folge uns auf',
    legalLinks: [
      // { name: 'Kontakt', link: 'https://think-internet.de/kontakt/' },
      // { name: 'Impressum', link: 'https://think-internet.de/impressum/' },
      // { name: 'Datenschutz', link: 'https://think-internet.de/datenschutz/' },
    ],
    socialLinks: [],
  },

  generic: {
    level: {
      title: 'Rolle',
      [Level.ADMIN]: 'Verwaltung',
    },
    company: {
      name: 'Think Internet Operations GmbH',
      street: 'Alt-Tempelhof 37',
      city: '13585 Berlin',
      phone: '+49 00 00 00 00',
      mail: 'ai@think-internet.de',
    },
    costs: 'Kosten',
    remove: 'Löschen',
    mitarbeiterAmount: 'Mitarbeiteranzahl',
    download: 'Download',
    amountSuffix: ' Stück',
    meterSuffix: ' Meter',
    laufmeterSuffix: ' Laufmeter',
    settings: 'Einstellungen',
    hourSuffix: ' Stunden',
    squareMeter: 'Quadratmeter',
    squareMeterSuffix: ' m²',
    cubicMeterSuffix: ' m³',
    percentageSuffix: ' %',
    euroSuffix: ' €',
    equals: ' = ',
    timestampPrefix: 'Erstellt am: ',
    phonePrefix: 'Telefon: ',
    mailPrefix: 'E-Mail: ',
    websitePrefix: 'Webseite: ',
    employeeSuffix: ' Mitarbeiter',
    salutation: 'Anrede',
    name: 'Name',
    firstname: 'Vorname',
    lastname: 'Nachname',
    birthday: 'Geburtsdatum',
    personType: 'Art',
    personTypePlaceholder: 'Beirat, Entscheider, ...',
    street: 'Straße, Hausnummer',
    companyName: 'Firmenname',
    club: 'Verein (optional)',
    city: 'PLZ, Ort',
    mail: 'E-Mail-Adresse',
    identifier: 'E-Mail-Adresse',
    message: 'Ihre Anfrage...',
    phone: 'Telefonnummer',
    password: 'Passwort',
    passwordRepeat: 'Passwort wiederholen',
    createdOn: 'Erstellt am',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    close: 'Schließen',
    send: 'Senden',
    error: 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es später erneut.',
    acceptAGB: 'Ich akzeptiere die AGB',
    percent: ' %',
    kilometerSuffix: ' km',
    upload: 'Hochladen',
    login: 'Anmelden',
    logout: 'Abmelden',
    export: 'Export',
    import: 'Import',
    save: 'Speichern',
    copy: 'Kopieren',
  },

  UI: {
    dateRangePicker: {
      label: 'Datumsbereich',
      labelSingleSelect: 'Datum',
    },
    yearSelector: {
      cta: 'Jahresauswahl',
      title: 'Jahresauswahl',
    },
    monthSelector: {
      cta: 'Monatsauswahl',
      title: 'Monatsauswahl',
    },
    confirmation: {
      title: 'Bestätigung',
    },
    removeConfirmation: {
      title: 'Bestätigung',
      text: (itemName: string) => `Möchten Sie "${itemName}" wirklich löschen?`,
    },
    copyConfirmation: {
      title: 'Kopieren',
      text: (itemName: string) => `${itemName}-Kopie umbenennen zu:`,
      initNameSuffix: '-Kopie',
    },
    simpleList: {
      search: 'Suche',
      resultAmountSuffixPlural: ' Ergebnisse',
      resultAmountSuffixSingular: ' Ergebnis',
      noData: 'Keine Daten vorhanden',
    },
    multiList: {
      search: 'Suche',
      resultAmountSuffix: ' Ergebnisse',
      noData: 'Keine Daten vorhanden',
      cta: 'Ausführen',
      cancelCTA: 'Abbrechen',
      option: {
        EXPORT: 'Export',
        PROCESS: 'Verarbeiten',
        STOP: 'Stoppen',
      },
      export: {
        title: 'Export',
        identifier: 'Kennung',
      },
      error: 'Aktion konnte nicht ausgeführt werden',
    },
    csvImport: {
      title: 'Import',
      startCTA: 'Import starten',
      loading: 'Daten werden imporiert...',
      error: 'Der Import ist fehlgeschlagen.',
    },
    dropdown: {
      emptySelection: 'Bitte wählen',
      search: 'Suche',
    },
    selectableTagList: {
      showMore: 'Mehr anzeigen',
      showLess: 'Weniger',
    },
    crmCard: {
      idPrefix: 'ID',
      name: 'Name',
      externalId: 'Externe ID',
      uuid: 'UUID',
      emails: 'E-Mails',
      phone: 'Telefon',
      addresses: 'Adressen',
      createdAt: 'Erstellt',
      updatedAt: 'Aktualisiert',
      company: 'Unternehmen',
      deal: 'Deal',
      firstname: 'Vorname',
      lastname: 'Nachname',
      position: 'Position',
    },
    textarea: {
      max: {
        prefix: 'maximal ',
        suffix: ' Zeichen',
      },
    },
    dnd: {
      text: 'Bewerbung anhängen',
      hint: '(Erlaubt ist eine PDF-Datei bis zu 25 MB)',
      selectedPrefix: 'Gewählte PDF: ',
      error: {
        size: 'Maximale Dateigröße überschritten',
      },
    },
  },

  resetPassword: {
    passwordsDontMatch: 'Passwörter stimmen nicht überein',
    passwordReset: 'Passwort wurde erfolgreich geändert',
    save: 'Ändern',
    password: 'Passwort',
    passwordRepeat: 'Passwort wiederholen',
    title: 'Passwort ändern',
  },

  landing: {
    nav: {
      leistungen: 'Leistungen',
      projekte: 'Projekte',
      kompetenz: 'Kompetenz',
      team: 'Team',
      kontakt: 'Kontakt',
    },
    navItems: [
      { key: 'projekte', href: '#projekte' },
      { key: 'leistungen', href: '#kompetenz' },
      { key: 'team', href: '#team' },
      { key: 'kontakt', href: '#kontakt' },
    ],
    cta: {
      jetztAnfragen: 'Jetzt anfragen',
    },
    intro: {
      default: {
        headline: 'Von der ersten Idee bis zum schlüsselfertigen Mieterausbau',
        body: 'Von der ersten Idee über die Planung bis zur schlüsselfertigen Übergabe erhalten Sie mit Design & Build alle Leistungen aus einer Hand. Durch die enge Verzahnung von Architektur, Technik und Bauausführung werden Kostenüberschreitungen und zeitliche Verzögerungen minimiert. Ein einziger Ansprechpartner sorgt für klare Kommunikation, schnelle Entscheidungen und transparente Abläufe. So entsteht Ihr Projekt effizient, termingerecht und nach höchsten Qualitätsstandards ohne Schnittstellenprobleme zwischen Planung und Bau.',
        ctaLabel: 'MPS ARCHONIC Projekte',
        ctaHref: '#projekte',
      },
      analyse: {
        label: 'Analyse',
        headline: 'Zukunftsfähige Lösungen mit Hilfe von neuester Technologie',
        body: 'Mit einer gezielten Analyse vor dem Design & Build-Prozess ermitteln wir die individuellen Bedürfnisse und Bedarfe Ihres Projekts.',
        ctaLabel: 'Mehr zur Analysesoftware',
        ctaHref: '#analyse',
        servicesLabel: 'Leistungen',
        servicesList: [
          'Präzise Erhebung von Nutzer- und Organisationsbedarfen',
          'Effiziente Berechnung von Flächenprogrammen',
          'Vergleich von Arbeitsplatzszenarien',
          'Individuelle Anpassung des Arbeitsplatzkonzepts',
          'Datenbasierte Entscheidungsgrundlage für die Zukunft',
        ],
      },
      design: {
        label: 'Design',
        headline: 'Entwicklung eines ganzheitlichen Gestaltungskonzepts',
        body: 'Auf Basis der ermittelten Anforderungen entwickeln wir ein Konzept, das Funktion, Gestaltung und Projektziele zusammenführt.',
        ctaLabel: 'Mehr zur Leistung „Design"',
        ctaHref: '#design',
        servicesLabel: 'Leistungen',
        servicesList: [
          'Entwicklung eines maßgeschneiderten Gesamtkonzepts',
          'Integration funktionaler, gestalterischer und technischer Anforderungen',
          'Iterative Abstimmung und Weiterentwicklung des Entwurfs',
          'Berücksichtigung moderner Innenarchitekturkonzepte',
          'Klare gestalterische Grundlage für die Realisierungsphase',
        ],
      },
      build: {
        label: 'Build',
        headline: 'Präzise Umsetzung des Entwurfs bis zur finalen Fertigstellung',
        body: 'Wir steuern alle Beteiligten und sorgen für eine strukturierte und effiziente Umsetzung des Projekts.',
        ctaLabel: 'Mehr zur Leistung „Build"',
        ctaHref: '#build',
        servicesLabel: 'Leistungen',
        servicesList: [
          'Koordination und Steuerung aller ausführenden Gewerke',
          'Kontinuierliche Qualitäts- und Fortschrittskontrolle',
          'Effiziente Abläufe durch strukturierte Prozesse',
          'Flexibles Reagieren auf Herausforderungen während der Ausführung',
          'Abschlusskontrolle und Übergabe des fertiggestellten Projekts',
        ],
      },
    },
    advantages: {
      kicker: 'Ihre Vorteile auf einen Blick',
      heading: 'Wir übernehmen die gesamte Projektverantwortung',
      lead: 'Als Ihr Design & Build Partner übernehmen wir die Gesamtverantwortung für Ihr Projekt – vom Mieterausbau bis zur Revitalisierung, als Einzelprojekt oder Multi-Site-Lösung. Wir bündeln alle Kompetenzen in einem Team und begleiten Sie von der Planung bis zur Umsetzung.',
      items: [
        {
          title: 'Risiko-<br/>minimierung',
          text: 'Durch nahtlos verzahnte Planung und Ausführung aus einer Hand werden Schnittstellen minimiert und Abläufe optimal aufeinander abgestimmt.',
        },
        {
          title: '30%<br/>Zeitgewinn',
          text: 'Parallele Prozesse, kurze Entscheidungswege und ein zentraler Ansprechpartner beschleunigen die Umsetzung des gesamten Bauprojekts.',
        },
        {
          title: 'Schnelle<br/>Kostensicherheit',
          text: 'Frühe Kostensicherheit, reduzierte Koordinationsaufwände und weniger Reibungsverluste führen zu nachhaltig wirtschaftlicheren Projekten.',
        },
      ],
    },
    timeline: {
      topTitle: 'Bei einem Design & Build Prozess herrscht ab hier bereits Kostensicherheit',
      bottomTitle: 'Üblicher sequenzieller Projektverlauf',
      designBuildPhases: ['Entwurf', 'Ausführungsplanung', 'Bauausführung'],
      sequentialPhases: ['Entwurf', 'Ausführungsplanung', 'Ausschreibung', 'Vergabe', 'Bauausführung'],
      costFixLabel: 'Kosten Fix',
      timeSavingsLabel: '30% Zeitgewinn',
    },
    services: {
      analyse: {
        title: 'Analyse',
        text: 'Mit einer gezielten Analyse vor dem Design & Build-Prozess ermitteln wir die individuellen Bedürfnisse und Bedarfe Ihres Projekts.',
        bullets: [
          'Präzise Erhebung von Nutzer- und Organisationsbedarfen',
          'Effiziente Berechnung von Flächenprogrammen',
          'Vergleich von Arbeitsplatzszenarien',
          'Datenbasierte Entscheidungsgrundlage für die Zukunft',
        ],
      },
      design: {
        title: 'Design',
        text: 'Auf Basis der ermittelten Anforderungen entwickeln wir ein Konzept, das Funktion, Gestaltung und Projektziele zusammenführt.',
        bullets: [
          'Entwicklung eines maßgeschneiderten Gesamtkonzepts',
          'Integration funktionaler, gestalterischer und technischer Anforderungen',
          'Iterative Abstimmung und Weiterentwicklung des Entwurfs',
          'Klare gestalterische Grundlage für die Realisierungsphase',
        ],
      },
      build: {
        title: 'Build',
        text: 'Wir steuern alle Beteiligten und sorgen für eine strukturierte und effiziente Umsetzung des Projekts.',
        bullets: [
          'Koordination und Steuerung aller ausführenden Gewerke',
          'Kontinuierliche Qualitäts- und Fortschrittskontrolle',
          'Effiziente Abläufe durch strukturierte Prozesse',
          'Abschlusskontrolle und termingerechte Übergabe',
        ],
      },
    },
    benefits: {
      items: [
        {
          title: 'Schnelle Kostensicherheit',
          text: 'Frühe Kostensicherheit, reduzierte Koordinationsaufwände und weniger Reibungsverluste führen zu nachhaltig wirtschaftlicheren Projekten.',
        },
        {
          title: '30% Zeitgewinn',
          text: 'Parallele Prozesse, kurze Entscheidungswege und ein zentraler Ansprechpartner beschleunigen die Umsetzung des gesamten Bauprojekts.',
        },
        {
          title: 'Risikominimierung',
          text: 'Durch nahtlos verzahnte Planung und Ausführung aus einer Hand werden Schnittstellen minimiert und Abläufe optimal aufeinander abgestimmt.',
        },
      ],
    },
    investment: {
      heading: 'Sicher investieren mit Design & Build',
      lead: 'Design & Build reduziert Risiken und schafft Planungssicherheit. Erfahren Sie, wie Sie von effizienten Abläufen und früher Kostensicherheit profitieren.',
      topics: [
        {
          title: 'Schnellere Vermietung und höhere Flächeneffizienz',
          bullets: [
            'Beschleunigte Projektlaufzeit durch parallele Planungs- und Ausführungsphasen',
            'Frühzeitige Abstimmung mit Mietern',
            'Terminsichere Übergabevorbereitung',
          ],
        },
        {
          title: 'Wettbewerbsvorteil am Vermietungsmarkt',
          bullets: [
            'Marktgerechte Flächenkonzepte',
            'Flexible Ausbauoptionen für unterschiedliche Nutzerprofile',
            'Zukunftsfähige technische Standards',
          ],
        },
        {
          title: 'Wertsteigerung und nachhaltige Qualität',
          bullets: [
            'Ganzheitliche Betrachtung von Architektur, Technik und Wirtschaftlichkeit',
            'Nachhaltige Materialien und langlebige Lösungen',
            'Optimierte Betriebskosten',
          ],
        },
        {
          title: 'Planungssicherheit und klare Verantwortung',
          bullets: [
            'Ein zentraler Ansprechpartner für Planung und Ausführung',
            'Frühzeitige Kostentransparenz und belastbare Budgets',
            'Verbindliche Terminplanung durch integrierte Steuerung',
          ],
        },
      ],
    },
    faq: {
      heading: 'Schneller vermieten. Sicher investieren.',
      lead: 'Design & Build beschleunigt die Projektlaufzeit und reduziert so Leerstände. Durchdachte Konzepte steigern den Wert der Immobilie und erhöhen ihre Attraktivität für potenzielle Mieter.',
      items: [
        {
          title: 'Schnellere Vermarktung & kürzerer Leerstand',
          bullets: [
            'Schnellere Vermietung und höhere Flächeneffizienz',
            'Beschleunigte Projektlaufzeit durch parallele Planungs- und Ausführungsphasen',
            'Frühzeitige Abstimmung mit Mietern',
            'Übergabe terminsicher vorbereitet',
          ],
        },
        {
          title: 'Höhere Attraktivität der Immobilie',
          bullets: [
            'Wettbewerbsvorteil am Vermietungsmarkt',
            'Marktgerechte Flächenkonzepte',
            'Flexible Ausbauoptionen für unterschiedliche Nutzerprofile',
            'Zukunftsfähige technische Standards',
          ],
        },
        {
          title: 'Wertsteigerung & nachhaltige Qualität',
          bullets: [
            'Langfristige Sicherung und Steigerung des Immobilienwerts',
            'Ganzheitliche Betrachtung von Architektur, Technik und Wirtschaftlichkeit',
            'Nachhaltige Materialien und langlebige Lösungen',
            'Optimierte Betriebskosten',
          ],
        },
        {
          title: 'Planungssicherheit & klare Verantwortung',
          bullets: [
            'Geringeres Projektrisiko für Eigentümer',
            'Ein zentraler Ansprechpartner für Planung und Ausführung',
            'Frühzeitige Kostentransparenz und belastbare Budgets',
            'Verbindliche Terminplanung durch integrierte Steuerung',
            'Reduzierte Schnittstellen und minimiertes Nachtragsrisiko',
          ],
        },
      ],
    },
    highlights: {
      kicker: 'Unsere Projekte',
      headline: 'Weil Taten mehr sagen als Worte: Machen Sie sich ein Bild von unserer Arbeit.',
      projects: [
        { name: 'MPS ARCHONIC, Stuttgart', area: '550 m²', duration: '5 Monate' },
        {
          name: 'Rösler Oberflächentechnik, Untermerzbach',
          area: '6.000 m²',
          duration: '12 Monate',
          link: 'https://www.mps-archonic.com/referenzen/roesler-innowelt/',
        },
        {
          name: 'Freudenberg Technology Innovation, Weinheim',
          area: '1.500 m²',
          duration: '12 Monate',
          link: 'https://www.mps-archonic.com/referenzen/freudenberg-technology-innovation/',
        },
        {
          name: 'Enoplan, Bruchsal',
          area: '700 m²',
          duration: '20 Monate',
          link: 'https://www.mps-archonic.com/referenzen/enoplan-new-work/',
        },
        {
          name: 'Witzenmann GmbH, Pforzheim',
          area: '350 m²',
          duration: '6 Monate',
          link: 'https://www.mps-archonic.com/referenzen/witzenmann-living-lab/',
        },
        {
          name: 'MPS Archonic, Bietigheim',
          area: '600 m²',
          duration: '12 Monate',
          link: 'https://www.mps-archonic.com/referenzen/mps-archonic-neue-arbeitswelt/',
        },
        {
          name: 'Wolff & Müller GmbH, Stuttgart',
          area: '2.400 m²',
          duration: '24 Monate',
          link: 'https://www.mps-archonic.com/referenzen/wolff-mueller-campus/',
        },
      ],
      nextImage: 'Nächstes Bild',
      moreInformation: 'Mehr zu diesem Projekt',
    },
    team: {
      kicker: 'Unser Team',
      headline: 'Menschen, die unsere Vision weltweit vorantreiben',
      members: ['Nicole Coppola', 'Nathalie Tscherna', 'Jana Kremser', 'Sandra Bamberg', 'Christoph Beer', 'Fatih Aygün'],
    },
    competences: {
      kicker: 'Unsere Leistungen',
      heading: 'Mit diesen Kompetenzen meistern wir jedes Projekt',
      lead: 'Bauprojekte sind komplex und zukunftsfähiges Bauen erfordert interdisziplinäre Ansätze. Wir haben alle Fachkompetenzen im Haus um effiziente, sichere und zukunftsfähige Lösungen sicherzustellen.',
      items: [
        {
          title: 'Planung',
          text: 'Wir erarbeiten individuelle Konzepte, die Technik, Wirtschaftlichkeit und Gestaltung in Einklang bringen. Mit fundiertem Know-how und kreativen Ideen schaffen wir passgenaue Lösungen mit überzeugendem Design.',
          image: '/competences/planung.jpg',
        },
        {
          title: 'TGA',
          text: 'Unsere Expertinnen und Experten für Technische Gebäudeausrüstung entwickeln individuelle Konzepte, die Energieeffizienz, Betriebssicherheit und hohen Nutzerkomfort optimal vereinen.',
          image: '/competences/tga.jpg',
        },
        {
          title: 'Brandschutz',
          text: 'Gemeinsam mit unseren Expertinnen und Experten für Brandschutz verbinden wir Sicherheit, Normkonformität und Gestaltung zu ganzheitlichen Lösungen.',
          image: '/competences/brandschutz.jpg',
        },
        {
          title: 'Statik',
          text: 'Bei projektspezifischem Bedarf bringen wir für den Innenausbau die nötige statische Kompetenz ein und gewährleisten so sichere und wirtschaftliche Lösungen.',
          image: '/competences/statik.jpg',
        },
      ],
    },
    processes: {
      tagline: 'Klare Abläufe. Volle Transparenz. Ganzheitliche Projektabwicklung.',
      headingLines: ['MPS ARCHONIC Analytics –', 'Arbeitsplatzkonzepte mit', 'intelligenter Strategie'],
      body: 'Unsere innovative Analyse-Software ermittelt präzise den Raumbedarf und schafft die Grundlage für fundierte, datenbasierte Entscheidungen. Durch die Kombination aus digitaler Bedarfsermittlung und strategischen Zielen entstehen maßgeschneiderte Arbeitsplatzszenarien, die perfekt auf die Anforderungen Ihres Unternehmens abgestimmt sind. So optimieren Sie Ihre Flächennutzung nachhaltig und flexibel, inklusive zukunftsfähiger Konzepte wie Desksharing.',
      image: '/processes/analytics-laptop.png',
    },
    analysis: {
      title: 'Analyse',
      stepLabel: 'Schritt',
      intro: 'Mit einer gezielten Analyse vor dem Design & Build-Prozess ermitteln wir die individuellen Bedürfnisse und Bedarfe Ihres Projekts.',
      steps: [
        {
          stepNumber: '01',
          title: 'Umfrage',
          text: 'Eine strukturierte Umfrage bildet die Grundlage für eine fundierte Bedarfsanalyse. Mithilfe digitaler Tools werden alle notwendigen Nutzer- und Organisationsanforderungen erfasst.',
        },
        {
          stepNumber: '02',
          title: 'Auswertung',
          text: 'Die erhobenen Daten werden systematisch analysiert. Dadurch werden Nutzungsbedarfe, Flächenpotenziale und organisatorische Anforderungen sichtbar und in ein Raumprogramm überführt. Die Auswertung bildet die Grundlage für die Entwicklung eines optimal abgestimmten Konzepts.',
        },
        {
          stepNumber: '03',
          title: 'Ergebnis',
          text: 'Auf Basis der Analyse entsteht ein klar definiertes Arbeitsplatz- und Flächenkonzept. Es zeigt auf, wie Arbeitsbereiche optimal organisiert und Flächen effizient genutzt werden können. Das Ergebnis bildet eine belastbare Grundlage für die zukünftige Planung.',
        },
      ],
      graphics: {
        workMethods: 'Ihre Arbeitsweisen',
        percentLabel: '100% / 100%',
        singleWork: 'Einzelarbeit',
        communication: 'Kommunikation',
        collaboration: 'Kollaboration',
        workplace: 'Arbeitsplatz',
        meeting: 'Besprechung',
        specialAreas: 'Sonderflächen',
      },
    },
    design: {
      title: 'Design',
      stepLabel: 'Schritt',
      processTitle: 'Design Prozess',
      intro: 'Auf Basis der ermittelten Anforderungen entwickeln wir ein Konzept, das Funktion, Gestaltung und Projektziele zusammenführt.',
      steps: [
        {
          stepNumber: '01',
          title: 'Projektplanung',
          text: 'In dieser Phase wird der Projektplan erstellt und der Budgetrahmen abgestimmt. Ein Aufmaß sowie eine fotografische Bestandsdokumentation bilden die Planungsbasis. Darauf aufbauend entsteht ein Vorentwurf mit einer ersten Kostenschätzung.',
        },
        {
          stepNumber: '02',
          title: 'Entwurf',
          text: 'Der Vorentwurf wird zum Entwurf weiterentwickelt und in konkrete Planunterlagen überführt. Parallel dazu wird das Budget überprüft und abgestimmt. Die Fach- und Genehmigungsplanung startet, erste Bemusterungen werden vorbereitet und gemeinsam mit Fachunternehmern werden Begehungen durchgeführt. Auf dieser Basis entsteht die finale Kostenübersicht.',
        },
      ],
      processSteps: [
        {
          title: 'Schritt 01 - Projektplanung',
          text: 'Projektplan und Budgetrahmen werden abgestimmt, Aufmaß und Bestandsdokumentation bilden die Planungsbasis.',
        },
        {
          title: 'Schritt 02 - Entwurf',
          text: 'Der Vorentwurf wird zum konkreten Entwurf, inklusive Budgetabgleich, Fachplanung und finaler Kostenübersicht.',
        },
      ],
      gantt: {
        smallProjects: 'Kleinere Projekte – Agile Entwicklung',
        smallRange: '<100 m² / <10 Wochen',
        mediumProjects: 'Mittlere Projekte – Produktentwicklung und Rollout',
        mediumRange: '100 - 500 m² / 10 - 25 Wochen',
        largeProjects: 'Große Projekte – Durchlaufende Teamarbeit',
        largeRange: '>500 m² / > 25 Wochen',
      },
    },
    build: {
      title: 'Build',
      stepLabel: 'Schritt',
      processTitle: 'Build Prozess',
      intro: 'Wir steuern alle Beteiligten und sorgen für eine strukturierte und effiziente Umsetzung des Projekts.',
      steps: [
        {
          stepNumber: '01',
          title: 'Bauvorbereitung',
          text: 'Auf Basis des Entwurfs werden die organisatorischen und technischen Grundlagen für die Umsetzung geschaffen. Die Gewerke werden terminiert, Materialien mit langen Lieferzeiten frühzeitig bestellt und das Projekt intern an das Ausführungsteam übergeben. Parallel wird der Anfrage- und Vergabeprozess für die beteiligten Gewerke durchgeführt.',
        },
        {
          stepNumber: '02',
          title: 'Bauausführung',
          text: 'Mit dem Start der Bauarbeiten wird das Projekt gemäß Terminplan umgesetzt. Während der Bauphase sorgen regelmäßige Status- und Abstimmungsgespräche für Transparenz und einen reibungslosen Ablauf. Vor der offiziellen Abnahme erfolgt eine gemeinsame Abschlussbegehung, um die Ausführung zu prüfen und letzte Punkte zu klären.',
        },
        {
          stepNumber: '03',
          title: 'Bauabnahme',
          text: 'Zum Projektende erfolgt die finale Abnahme mit einer gemeinsamen Mängelbegehung. Anschließend erhalten Sie die vollständige Abschlussdokumentation mit Gewährleistungen, Fotos und Materiallisten. Auch nach der Übergabe bleiben wir Ihr Ansprechpartner und begleiten das Projekt mit einer Nachbetreuung sowie einem abschließenden Feedbackgespräch.',
        },
      ],
      processSteps: [
        {
          title: 'Schritt 01 - Bauvorbereitung',
          text: 'Gewerke werden terminiert, Materialien frühzeitig bestellt und der Vergabeprozess vorbereitet.',
        },
        {
          title: 'Schritt 02 - Bauausführung',
          text: 'Das Projekt wird gemäß Terminplan umgesetzt, mit regelmäßigen Statusgesprächen für maximale Transparenz.',
        },
        { title: 'Schritt 03 - Bauabnahme', text: 'Finale Abnahme, vollständige Abschlussdokumentation und Nachbetreuung bis zum Projektabschluss.' },
      ],
    },
    analytics: {
      title: 'MPS ARCHONIC Analytics – Arbeitsplatzkonzepte mit intelligenter Strategie',
      lead: 'Unsere innovative Analyse-Software ermittelt präzise den Raumbedarf und schafft die Grundlage für fundierte, datenbasierte Entscheidungen.',
      body: 'Durch die Kombination aus digitaler Bedarfsermittlung und strategischen Zielen entstehen maßgeschneiderte Arbeitsplatzszenarien, die perfekt auf die Anforderungen Ihres Unternehmens abgestimmt sind.',
      steps: [
        {
          title: 'Schritt 01 - Umfrage',
          text: 'Eine strukturierte Umfrage bildet die Grundlage für eine fundierte Bedarfsanalyse mit digitalen Tools.',
        },
        {
          title: 'Schritt 02 - Auswertung',
          text: 'Die erhobenen Daten werden systematisch analysiert und in ein abgestimmtes Raumprogramm überführt.',
        },
        {
          title: 'Schritt 03 - Ergebnis',
          text: 'Es entsteht ein klar definiertes Arbeitsplatz- und Flächenkonzept als belastbare Grundlage für die weitere Planung.',
        },
      ],
    },
    contact: {
      kicker: 'Ihr Kontakt',
      imagePlaceholder: 'Bild',
      heading: 'Starten Sie unser gemeinsames Projekt',
      question: 'Sie möchten mehr über die ersten Schritte und weitere Vorgehensweise erfahren?',
      body: 'Nicole Coppola freut sich auf ein unverbindliches Erstgespräch mit Ihnen. Machen Sie jetzt einen Termin aus.',
      ctaLabel: 'Kontakt aufnehmen',
      ctaHref: '#kontakt',
      image: '/contact/contact-person.jpg',
      popoverHeadline: 'Lassen Sie uns über Ihre Pläne sprechen.',
      popoverPhoneLabel: 'Telefon:',
      popoverEmailLabel: 'E-Mail:',
      popoverCtaLabel: 'Online-Termin vereinbaren',
      popoverCtaHref: '#kontakt',
    },
    footer: {
      companyName: 'MPS ARCHONIC GmbH',
      address: 'Motorstraße 26, 70499 Stuttgart',
      contactLabel: 'Kontakt',
      phone: '+49 711 13 99 650',
      email: 'mail@mps-archonic.com',
      instagram: 'Instagram',
      linkedIn: 'LinkedIn',
      copyright: '© MPS ARCHONIC GmbH',
      impressum: 'Impressum',
      datenschutz: 'Datenschutz',
      phoneHref: 'tel:+497111399650',
      emailHref: 'mailto:mail@mps-archonic.com',
      instagramHref: 'https://www.instagram.com/archonic.gmbh/',
      linkedInHref: 'https://www.linkedin.com/company/archonic-createworkflow/',
      impressumHref: 'https://www.mps-archonic.com/impressum/',
      datenschutzHref: 'https://www.mps-archonic.com/datenschutz/',
    },
  },
}

export const langKey = 'DE'
